<div>
  <app-header></app-header>
  <app-navbar></app-navbar>
  <ng-content></ng-content>
</div>
